import { useMemo } from 'react';
import { Select } from '../common/Select';

interface DeviceSelectProps {
  label: string;
  devices: { deviceId: string; label: string }[];
  selectedId: string;
  onSelect: (id: string) => void;
}

/**
 * Dropdown selector for media devices.
 */
export function DeviceSelect({ label, devices, selectedId, onSelect }: DeviceSelectProps) {
  const options = useMemo(() => {
    if (devices.length === 0) {
      return [{ value: '', label: `No ${label.toLowerCase()}s found` }];
    }

    return devices.map((device) => ({
      value: device.deviceId,
      label: device.label || `${label} ${device.deviceId.slice(0, 4)}`,
    }));
  }, [devices, label]);

  return (
    <Select
      label={label}
      value={selectedId}
      onChange={(event) => onSelect(event.target.value)}
      options={options}
    />
  );
}
